import React, { useState } from 'react';

function SidebarMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`sidebar-menu ${isOpen ? 'open' : ''}`}>
      <button onClick={toggleMenu}>Toggle Menu</button>
      <ul>
        <li>Home</li>
        <li>Challenges</li>
        <li>Settings</li>
      </ul>
    </div>
  );
}

export default SidebarMenu;